import styled from 'styled-components'

const StripeErrorUi = styled.div`
  font-size: 13px;
  color: red;
  margin-top: 5px;
`

export default StripeErrorUi
